import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { getLocationPathname } from '../../shared/utils/location';

export const { Types: RouterTypes, Creators: RouterActions } = createActions(
  {
    setCurrentPathname: ['pathname'],
    listen: null,
  },
  { prefix: 'ROUTER_' }
);

export const INITIAL_STATE = Immutable({
  prevPathname: null,
  currentPathname: getLocationPathname(),
});

export const setCurrentPathname = (state, { pathname }) =>
  state.set('prevPathname', state.currentPathname).set('currentPathname', pathname);

export const reducer = createReducer(INITIAL_STATE, {
  [RouterTypes.SET_CURRENT_PATHNAME]: setCurrentPathname,
});
